var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _Swiper_handlers;
import 'hammerjs';
import VideoManager from "./VideoManager";
import Video from "./Video";
import { isWebpSupported } from "../../utils";
import EventBus from "../../events/EventBus";
var IPHONE_FIX_DELAY_MS = 1500;
var FIRST_SLIDE_CLASS_NAME = 'first';
var SwiperController = /** @class */ (function () {
    function SwiperController(selector, pixelRatio) {
        this.selector = selector;
        this.pixelRatio = pixelRatio;
        this.instances = [];
        this.pixelRatio = (pixelRatio > 1.5 ? 2 : 1);
        this.videoManager = new VideoManager();
    }
    SwiperController.prototype.update = function () {
        var _this = this;
        document.querySelectorAll(this.selector).forEach(function (element) {
            if (element.dataset.swiperInitialized) {
                return;
            }
            if (element.querySelectorAll('.prod-teaser__dot').length < 2) {
                return;
            }
            var swiper = new Swiper(element, _this.pixelRatio, _this.videoManager);
            _this.instances.push(swiper);
            var image = swiper.img;
            image.addEventListener('click', function () {
                setTimeout(function () {
                    if (!image.naturalWidth) {
                        image.src = image.src.replace(/#.*/, '') + '#' + new Date().getTime();
                    }
                }, IPHONE_FIX_DELAY_MS);
            });
        });
    };
    SwiperController.prototype.destroy = function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.instances), _c = _b.next(); !_c.done; _c = _b.next()) {
                var instance = _c.value;
                instance.destroy();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.instances = [];
    };
    return SwiperController;
}());
export default SwiperController;
var Swiper = /** @class */ (function () {
    function Swiper(element, pixelRatio, manager) {
        var _this = this;
        this.element = element;
        this.manager = manager;
        this.srcList = [];
        _Swiper_handlers.set(this, {
            mouseLeave: null,
            mouseMove: null,
            imageLoad: null,
            click: null,
            setStripWidth: null,
        });
        this.loaded = [];
        this.loading = [];
        if (element.dataset.swiperInitialized) {
            // already initialized.
            return;
        }
        this.dots = Array.from(element.querySelectorAll('.prod-teaser__dot'));
        if (this.dots.length < 2) {
            return;
        }
        this.cover = element.querySelector('.prod-teaser__cover');
        this.img = this.cover.querySelector('img');
        this.setStripWidth();
        if (!this.img.complete) {
            var initSrcListOnload_1 = function () {
                _this.img.removeEventListener('load', initSrcListOnload_1);
                _this.initSrcList(pixelRatio);
            };
            this.img.addEventListener('load', initSrcListOnload_1, { once: true });
        }
        else {
            this.initSrcList(pixelRatio);
        }
        this.initHammer(this.cover);
        this.addEventListeners();
        element.dataset.swiperInitialized = 'true';
    }
    Swiper.prototype.setStripWidth = function () {
        this.stripWidth = (this.cover.clientWidth > this.cover.clientHeight ? this.cover.clientWidth : this.cover.clientHeight) / this.dots.length;
    };
    Swiper.prototype.onImageLoad = function () {
        this.dots.map(function (item) { return item.classList.remove('prod-teaser__dot--active'); });
        this.dots[this.activeIndex].classList.add('prod-teaser__dot--active');
        this.loaded[this.activeIndex] = true;
    };
    Swiper.prototype.onSwipeLeft = function () {
        this.activate(this.activeIndex === this.srcList.length - 1 ? 0 : this.activeIndex + 1);
    };
    Swiper.prototype.onSwipeRight = function () {
        this.activate(this.activeIndex === 0 ? this.srcList.length - 1 : this.activeIndex - 1);
    };
    Swiper.prototype.onClick = function (e) {
        this.activate(this.dots.indexOf(e.target));
    };
    Swiper.prototype.onMouseMove = function (e) {
        var left = Math.floor((this.video ? this.img : this.cover).getBoundingClientRect().left);
        var index = Math.floor((e.clientX - left) / this.stripWidth);
        this.activate(index < this.srcList.length ? index : index - 1);
    };
    Swiper.prototype.onMouseLeave = function () {
        this.activate(0);
        if (this.video && this.video.locked) {
            this.video.unlock();
        }
    };
    Swiper.prototype.activate = function (index) {
        var _this = this;
        var lockVideo = false;
        if (this.video && this.activeIndex !== undefined && !this.video.locked) {
            lockVideo = true;
        }
        if (index === this.activeIndex) {
            return;
        }
        if (this.srcList[index] === undefined) {
            return;
        }
        this.activeIndex = index;
        this.preloadImage(function () {
            if (!_this.loaded[_this.activeIndex]) {
                return;
            }
            if (lockVideo) {
                setTimeout(function () { return _this.video.lock(); });
            }
            _this.img.srcset = '';
            _this.img.src = _this.srcList[_this.activeIndex];
            _this.img.removeAttribute('width');
            _this.img.removeAttribute('height');
            if (_this.activeIndex === 0) {
                _this.cover.classList.add(FIRST_SLIDE_CLASS_NAME);
            }
            else if (_this.cover.classList.contains(FIRST_SLIDE_CLASS_NAME)) {
                _this.cover.classList.remove(FIRST_SLIDE_CLASS_NAME);
            }
        });
    };
    Swiper.prototype.destroy = function () {
        this.element.dataset.swiperInitialized = '';
        this.hammer.destroy();
        this.removeEventListeners();
        if (this.video) {
            this.manager.remove(this.video);
            this.video.destroy();
        }
    };
    Swiper.prototype.preloadImage = function (callback) {
        var _this = this;
        if (this.loading[this.activeIndex] || this.loaded[this.activeIndex]) {
            callback();
            return;
        }
        this.loading[this.activeIndex] = false;
        var image = document.createElement('img');
        image.onload = function () {
            _this.loaded[_this.activeIndex] = true;
            _this.loading[_this.activeIndex] = false;
            callback();
        };
        image.onerror = function () {
            _this.loading[_this.activeIndex] = false;
        };
        image.src = this.srcList[this.activeIndex];
    };
    Swiper.prototype.initSrcList = function (pixelRatio) {
        var e_2, _a;
        this.srcList.length = 0;
        var extension = isWebpSupported() ? 'webp' : 'jpg';
        try {
            for (var _b = __values(this.dots), _c = _b.next(); !_c.done; _c = _b.next()) {
                var dot = _c.value;
                this.srcList.push(dot.dataset[extension + (pixelRatio < 2 ? 'X1' : 'X2')]);
                if (dot.dataset.video) {
                    this.video = new Video(dot.dataset.video, this.cover, this.srcList[0]);
                    this.manager.add(this.video);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if (this.img.currentSrc) {
            this.activeIndex = 0;
            this.img.src = this.img.currentSrc;
        }
        else {
            this.activate(0);
        }
        this.img.removeAttribute('srcset');
        this.cover.querySelectorAll('source').forEach(function (item) { return item.parentNode.removeChild(item); });
    };
    Swiper.prototype.initHammer = function (element) {
        this.hammer = new Hammer(element);
        this.hammer.get('swipe').set({ threshold: 30 });
        this.hammer.on('swipeleft', this.onSwipeLeft.bind(this));
        this.hammer.on('swiperight', this.onSwipeRight.bind(this));
    };
    Swiper.prototype.addEventListeners = function () {
        var _this = this;
        this.cover.addEventListener('mouseleave', __classPrivateFieldGet(this, _Swiper_handlers, "f").mouseLeave = this.onMouseLeave.bind(this));
        this.cover.addEventListener('mousemove', __classPrivateFieldGet(this, _Swiper_handlers, "f").mouseMove = this.onMouseMove.bind(this));
        this.img.addEventListener('load', __classPrivateFieldGet(this, _Swiper_handlers, "f").imageLoad = this.onImageLoad.bind(this));
        this.dots.forEach(function (item) { return item.addEventListener('click', __classPrivateFieldGet(_this, _Swiper_handlers, "f").click = _this.onClick.bind(_this)); });
        EventBus.on('products:view-mode-change', __classPrivateFieldGet(this, _Swiper_handlers, "f").setStripWidth = this.setStripWidth.bind(this));
    };
    Swiper.prototype.removeEventListeners = function () {
        var _this = this;
        this.cover.removeEventListener('mouseleave', __classPrivateFieldGet(this, _Swiper_handlers, "f").mouseLeave);
        this.cover.removeEventListener('mousemove', __classPrivateFieldGet(this, _Swiper_handlers, "f").mouseMove);
        this.img.removeEventListener('load', __classPrivateFieldGet(this, _Swiper_handlers, "f").imageLoad);
        this.dots.forEach(function (item) { return item.removeEventListener('click', __classPrivateFieldGet(_this, _Swiper_handlers, "f").click); });
        EventBus.off('products:view-mode-change', __classPrivateFieldGet(this, _Swiper_handlers, "f").setStripWidth);
    };
    return Swiper;
}());
_Swiper_handlers = new WeakMap();
